module.exports = __webpack_public_path__ + "static/media/Laura Salisbury.d5db05cd.png";